{
  "adobeExperienceCloudNoOrgsSelect": "다른 조직 계정 선택",
  "adobeExperienceCloudSelectedOrg": "선택된 조직: {org}",
  "appSwitcherLinkOutIconLabel": "새 창에서 열림",
  "feedback button default": "피드백",
  "help": "도움말",
  "launchsidebar": "사이드바 실행",
  "more actions": "기타 액션",
  "searchButton": "검색",
  "solutionSwitcher": "다른 솔루션으로 전환",
  "solutionSwitcherList": "애플리케이션 목록",
  "solutionSwitcherPopover": "애플리케이션 목록 팝오버"
}
